import { jwtDecode } from 'jwt-decode';

interface TokenPayload {
    nroPedido: string;
    email: string;
    exp: number;
}

export const tokenHelper = {
    decodeToken(token: string): { nroPedido: string; email: string } | null {
        try {
            const decoded = jwtDecode<TokenPayload>(token);
            
            // Verificar si el token expiró
            // if (decoded.exp && decoded.exp < Date.now() / 1000) {
            //     console.error('Token expirado');
            //     return null;
            // }

            return {
                nroPedido: decoded.nroPedido,
                email: decoded.email
            };
        } catch (error) {
            console.error('Error al decodificar token:', error);
            return null;
        }
    }
};